import { SYSTEM_USER_ID } from 'src/util/constants';

/**
 * Generates a display name for a user based on their email, given name, and family name.
 * Returns an internationalized 'System' label when no user is provided.
 * @param {import('react-intl').IntlShape} intl - The intl object for internationalization.
 * @param {object} user - The user object containing email, givenName, and familyName properties.
 * @param {string} [userId=null] - The user's ID.
 * @returns {string} The display name for the user.
 */
const getUserDisplayName = (intl, user, userId = null) => {
  if (!user && userId !== SYSTEM_USER_ID) {
    return null;
  }

  if (userId === SYSTEM_USER_ID) {
    return intl.formatMessage({
      id: 'util.i18n.decorators.get_user_display_name.system.label',
      defaultMessage: 'System',
    });
  }

  const { email, givenName, familyName } = user;
  const name = [givenName, familyName].filter(Boolean).map((n) => n.trim()).filter(Boolean).join(' ');

  return (name === '' ? email : name);
};

export default getUserDisplayName;
